import type React from 'react';
import { Fragment } from 'react';
import times from 'lodash/times';
import { SkeletonCard } from 'app/shared/modules/listing-cards/ListingCardV3';

import './SkeletonListingCardGroup.scss';

interface SkeletonListingCardGroupProps {
  count?: number;
}

const SkeletonListingCardGroup: React.FC<SkeletonListingCardGroupProps> = ({ count = 1 }) => {
  return (
    <Fragment>
      {times(count, (n) => {
        return (
          <div className="SkeletonListingCard-wrapper-bigger-listing-card" key={n}>
            <SkeletonCard />
          </div>
        );
      })}
    </Fragment>
  );
};

export default SkeletonListingCardGroup;
